import React from "react";
import appService from "../../../services/app.service";
import { DetailsBase } from "../base/DetailsBase";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

export const NationalityDetails: React.FunctionComponent<{
    id: string | undefined;
    isAdmin:boolean;
}> = (props) => {
    const { id,isAdmin } = props;
    const { t } = useTranslation();
    const backButton = "/config/nationalities";
    const title = t("client:headers:tabNationality");

    if (isAdmin !== true) { return <NoAdminAlert /> }
    
    return (
            <DetailsBase id={id} backButton={backButton} getById={appService.getNationalityById} hasNumber={true} saveItem={appService.saveNationality} inputTitle={title}></DetailsBase>
        );
};
